module.exports = __webpack_public_path__ + "static/media/spanish-past-tense-table-7.8a353e5e.JPG";